import React from 'react';

export interface AccordionProps {
    title?: React.ReactNode;
    isExpanded?: boolean;
    isCollapsable?: boolean;
    children: React.ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({
    title,
    isExpanded: initialIsExpanded = true,
    isCollapsable = true,
    children,
}) => {
    const [isExpanded, set_isExpanded] = React.useState(initialIsExpanded);

    React.useEffect(() => {
        if (!isCollapsable) set_isExpanded(true);
    }, [isCollapsable]);

    return (
        <section
            style={{ position: 'relative' }}
            className={`accordion-item ${isExpanded ? 'is-active' : ''}`}
            data-accordion-item=''
        >
            {/* eslint-disable-next-line */}
            {isCollapsable && (
                <button
                    data-testid='accordion-collapse-link'
                    className='accordion-title'
                    aria-label={isExpanded ? 'Collapse' : 'Expand'}
                    onClick={(e) => {
                        e.preventDefault();
                        set_isExpanded(!isExpanded);
                    }}
                />
            )}
            {title && (
                <div
                    className='section-header'
                    onClick={() => set_isExpanded(!isExpanded)}
                >
                    {title}
                </div>
            )}
            <div
                style={{
                    display: isExpanded || !isCollapsable ? 'block' : 'none',
                }}
            >
                <div
                    className='accordion-content'
                    style={{ display: 'block' }}
                >
                    {children}
                </div>
            </div>
        </section>
    );
};
